var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homebase-background" },
    [
      !_vm.showSearchComponent ? _c("loading-overlay") : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c("div", [
          _c("div", [_c("outage-banner-card")], 1),
          _vm._v(" "),
          _c("div", [_c("campaign-card")], 1),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search-wrapper",
              class: { "search-results-visible": _vm.toggleHomepageContent }
            },
            [
              _c("enterprise-search", {
                key: _vm.componentKey,
                attrs: {
                  env: _vm.appEnv,
                  "es-user-access-token": _vm.authResponse.accessToken,
                  "es-user-id-token": _vm.authResponse.idToken,
                  "enable-url-params": false,
                  "disable-filters": false,
                  "user-id": _vm.authResponse.user.userName,
                  "user-email": _vm.authResponse.user.email,
                  "input-placeholder":
                    "Find answers, applications, articles, news and more...",
                  "customize-search": true,
                  "enable-employee-hub-search": true
                },
                on: {
                  onSearchKeywordChanged: _vm.searchKeywordChanged,
                  onWebComponentSuccess: _vm.onESComponentReady,
                  onWebComponentError: _vm.onESComponentError
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.toggleHomepageContent,
                  expression: "!toggleHomepageContent"
                }
              ],
              staticClass: "homebase-container container"
            },
            [_c("homebase-home")],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f3c5462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3c5462","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/HomePage.vue
// module id = null
// module chunks = 